'use client';

import { useFormatter, useTranslations } from 'next-intl';
import { useMemo } from 'react';
import { statusContribution } from '~/const/api';
import appConst from '~/const/appConst';
import { useContributorContext } from '../provider/ContributorProvider';

export const MultipleContributionReport = () => {
  const format = useFormatter();
  const t = useTranslations('SURVEY');
  const { contributions, status } = useContributorContext();

  const info = useMemo(() => ({
    submittedCount: status?.current_user_contributions_per_status_count?.submitted,
    last: contributions?.find(contribution => contribution.status === statusContribution.submitted),
  }), [contributions, status]);

  return info.submittedCount !== 0 && (
    <section className="last-report">
      <p className="last-report__count">
        {t('LAST_REPORT_COUNT')}
        {' '}
        {info.submittedCount > appConst.paginationItemsPerPage
          ? `${t('LAST_REPORT_COUNT_2')} ${appConst.paginationItemsPerPage}`
          : info.submittedCount}
        {' '}
        {t('LAST_REPORT_COUNT_3', {
          count: info.submittedCount,
        })}
      </p>
      {info.last?.submitted_at && (
        <p className="last-report__date">
          {t('LAST_REPORT_DATE', {
            lastUserContribDate: format.dateTime(
              new Date(info.last.submitted_at),
              appConst.dateFormat.fullDate,
            ),
          })}
        </p>
      )}
    </section>
  );
};
